import { useQuery } from '@tanstack/react-query'

import { confirmUser, ConfirmUserType } from '@/services/confirm-user'

export const CONFIRM_USER_QUERY = 'confirm-user'

export const useConfirmUser = (token: string, type: ConfirmUserType) => {
  const query = useQuery({
    queryKey: [CONFIRM_USER_QUERY, { token, type }],
    queryFn: ({ signal }) => confirmUser(token, type, signal),
    enabled: !!token,
    cacheTime: 0,
  })

  return query
}
